<script>
export default {
  name: "AlgoliaIndividualDateSearch",
};
</script>

<script setup>
// currentRefinement, range, refine, canRefine
import { ref, defineProps, watch, computed } from "vue";
import { getCalendarPt } from "@/components/program-manager/v2/style.js";
import Calendar from "primevue/calendar";

const props = defineProps({
  currentRefinement: {
    type: Object,
  },
  range: {
    type: Object,
  },
  refine: {
    type: Function,
  },
  canRefine: {
    type: Boolean,
  },
});

const localSlider = ref([]);
const outerRange = ref([]);
const areResultsBool = ref(true);

watch(
  () => props.currentRefinement,
  ({ min, max }) => {
    // only override handles if Algolia has actually refined
    if (min || max) {
      if (min != null) {
        const startDateObj = new Date();
        startDateObj.setTime(min);
        localSlider.value = [startDateObj, localSlider.value[1]];
      }
      if (max != null) {
        const endDateObj = new Date();
        endDateObj.setTime(max);
        localSlider.value = [localSlider.value[0], endDateObj];
      }
    } else localSlider.value = [];
  },
  { immediate: true }
);

watch(
  () => props.range,
  ({ min, max }) => {
    if (min == max) {
      areResultsBool.value = false;
    }
    if (min != null && max != null) {
      const startDateObj = new Date();
      startDateObj.setTime(min);
      const endDateObj = new Date();
      endDateObj.setTime(max);
      outerRange.value = [startDateObj, endDateObj];
    }
  },
  { immediate: true }
);

const startDate = computed({
  get() {
    return localSlider.value[0];
  },
  set(val) {
    localSlider.value = [val, localSlider.value[1]];
  },
});

const endDate = computed({
  get() {
    return localSlider.value[1];
  },
  set(val) {
    localSlider.value = [localSlider.value[0], val];
  },
});

const onChange = (startOrEndBool) => {
  if (startOrEndBool) {
    props.refine({ min: startDate.value.getTime(), max: props.currentRefinement.max });
  } else {
    props.refine({ min: props.currentRefinement.min, max: endDate.value.getTime() });
  }
};
</script>

<template>
  <div v-if="props.canRefine" class="p-2 flex flex-col w-full space-y-6">
    <div class="w-full max-w-xs">
      <label
        id="start-date-label"
        for="start-date"
        class="block -mt-3 ml-2 bg-white px-1 text-xs text-indigo-base font-bold"
        >Start Date</label
      >
      <Calendar
        v-model="startDate"
        :min-date="outerRange[0]"
        :max-date="outerRange[1]"
        :select-other-months="true"
        show-icon
        icon-display="input"
        :pt="getCalendarPt()"
        @date-select="() => onChange(true)"
      />
    </div>
    <div :class="{ invisible: !range }" class="relative w-full max-w-xs">
      <label
        id="end-date-label"
        for="end-date"
        class="block -mt-3 ml-2 bg-white px-1 text-xs text-indigo-base font-bold"
        >End Date</label
      >
      <Calendar
        v-model="endDate"
        :min-date="outerRange[0]"
        :max-date="outerRange[1]"
        :select-other-months="true"
        show-icon
        icon-display="input"
        :pt="getCalendarPt()"
        @date-select="() => onChange(false)"
      />
    </div>
  </div>
  <div v-else class="text-xs bg-gray-75 text-indigo-base rounded-md mt-1">
    <p>No options available. Clear a filter on another category.</p>
  </div>
</template>


